import { View } from "@components";
import styled from "styled-components";

export const Blur = styled(View)`
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: #00000000;
`;
